import Model from './Model';

export default class Vendor extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'vendors';
  }
}
